import React from 'react';
import { Link } from 'react-router-dom';
import { 
  MapPin, 
  Plane, 
  Car,
  ChevronRight
} from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import BookingWidget from '../components/BookingWidget';

const Location = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="location-page" className="min-h-screen pt-24 pb-32 bg-white">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">
          {t('nav.location')}
        </p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-6">
          {t('location.title')}
        </h1>
        <p className="text-muted-foreground text-lg max-w-2xl">
          {t('location.subtitle')}
        </p>
      </div>

      {/* Map Placeholder */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <div className="rounded-sm overflow-hidden border border-[#1E3A5F]/10">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d768.3438108121353!2d19.89694!3d39.6187541!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135b5f890c441e71%3A0xea185683b646636a!2sVilla%20Aristotle!5e0!3m2!1sde!2sgr!4v1774018877787!5m2!1sde!2sgr"
            width="100%"
            height="450"
            style={{border:0}}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Villa Aristotle Map"
          />
            </div>
      </div>

      {/* Getting Here */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <h2 className="font-serif text-2xl md:text-3xl text-[#1E3A5F] mb-8">{t('location.gettingHere')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-[#f8fafc] border border-[#1E3A5F]/10 rounded-sm p-8">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center">
                <Plane className="w-6 h-6 text-[#D4A72C]" />
              </div>
              <div>
                <h3 className="font-semibold text-[#1E3A5F]">{t('location.byAir')}</h3>
                <p className="text-sm text-muted-foreground">{t('location.byAirDesc')}</p>
              </div>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              {t('location.byAirText')}
            </p>
          </div>
          <div className="bg-[#f8fafc] border border-[#1E3A5F]/10 rounded-sm p-8">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#1E3A5F]/10 flex items-center justify-center">
                <Car className="w-6 h-6 text-[#D4A72C]" />
              </div>
              <div>
                <h3 className="font-semibold text-[#1E3A5F]">{t('location.byCar')}</h3>
                <p className="text-sm text-muted-foreground">{t('location.byCarDesc')}</p>
              </div>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              {t('location.byCarText')}
            </p>
          </div>
        </div>
      </div>

      {/* About Corfu */}
      <div className="bg-[#1E3A5F] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">
              {t('location.aboutTheIsland')}
            </p>
            <h2 className="font-serif text-3xl md:text-4xl text-white mb-6">
              {t('location.aboutCorfu')}
            </h2>
            <p className="text-white/70 leading-relaxed mb-6">
              {t('location.discoverCorfuText')}
            </p>
            <p className="text-white/70 leading-relaxed mb-6">
              {t('location.oldTownText')}
            </p>
            <Link to="/booking">
              <Button
                data-testid="location-book-btn"
                className="bg-[#D4A72C] text-[#1E3A5F] hover:bg-[#D4A72C]/90 btn-lift font-semibold"
                >
                <ChevronRight className="w-4 h-4 ml-2" />
                {t('booking.checkAvailability')}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Sticky Mobile Booking */}
      <BookingWidget variant="sticky" />
    </div>
  );
};

export default Location;
